import { Injectable } from "@angular/core";
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel } from "../business-entities/save-advance-search-filter";
import { AdvanceSearchDataService } from "../data-services/advance-search-data.service";
@Injectable({
  providedIn: 'root'
})

export class AdvanceSearchService {

  constructor(private service: AdvanceSearchDataService,
  ) {
  }
 
  SaveAdvanceSearchFilter(viewmodel: SaveAdvanceSearchFilterModel): Promise<any> {
    return this.service.SaveAdvanceSearchFilter(viewmodel);
  }

  GetAdvanceSearchList(moduleId:number): Promise<any> {
    return this.service.GetAdvanceSearchList(moduleId);
  }

  DeleteAdvanceSearch(moduel: DeleteAdvanceSearchFilterModel): Promise<any> {
    return this.service.DeleteAdvanceSearch(moduel);
  }
 
}
